import { render } from "./ShowcaseDesign.vue?vue&type=template&id=48d86f86&scoped=true"
import script from "./ShowcaseDesign.vue?vue&type=script&lang=js"
export * from "./ShowcaseDesign.vue?vue&type=script&lang=js"

import "./ShowcaseDesign.vue?vue&type=style&index=0&id=48d86f86&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48d86f86"]])

export default __exports__